import { hashKey, useQuery } from '@tanstack/react-query';

import { DeclarationListMetadata } from '@e-origin/contracts';
import { IDeclarationsCriteria } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDeclarationsMeta = (criteria: IDeclarationsCriteria) =>
  useQuery({
    queryKey: ['declarations-meta', hashKey([criteria])],
    queryFn: async (): Promise<DeclarationListMetadata> => {
      const { filters, sorting, pagination } = criteria;
      try {
        const result = await apiClient.declarations.declarationListMetadata.query({
          query: { criteria: JSON.stringify({ filters, sorting, pagination }) },
        });
        if (result.status !== 200) throw result.body;

        return result.body.metadata;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declarations meta');
      }
    },
    placeholderData: {
      total: 0,
      statusCounts: {} as DeclarationListMetadata['statusCounts'],
    },
  });
